import TileShapes from "../enums/TileShapes";
export var getTileDimensions = function (shape) {
    switch (shape) {
        case TileShapes.square1x:
            return { w: 1, h: 1 };
        case TileShapes.square2x:
            return { w: 2, h: 2 };
        case TileShapes.rectangle2x1:
            return { w: 2, h: 1 };
        case TileShapes.rectangle4x2:
            return { w: 4, h: 2 };
    }
};
export var getImageSize = function (shape) {
    switch (shape) {
        case TileShapes.square1x:
            return "400px x 400px";
        case TileShapes.square2x:
            return "800px x 800px";
        case TileShapes.rectangle2x1:
            return "872px x 400px";
        case TileShapes.rectangle4x2:
            return "1744px x 800px";
    }
};
/* eslint-disable */
export var isValidURL = function (url) {
    var res = url.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    return (res !== null);
};
